import {connect, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import React, {useCallback, useMemo, useRef, useState} from "react";
import {
    CAlert,
    CButton,
    CCol,
    CForm,
    CFormInput,
    CFormLabel,
    CFormSelect,
    CInputGroup,
    CInputGroupText, CModal, CModalBody, CModalHeader, CModalTitle, CNav, CNavItem, CNavLink,
    CRow, CTabContent, CTabPane
} from "@coreui/react";
import {AgGridReact} from "ag-grid-react";
import {Loading} from "../../../components/common";

import * as api from "../../../api/api";
import StoreDetail from "./StoreDetail";
import StoreListWhere from "../where/StoreListWhere";
import StoreCorner from "./StoreCorner";
import {requestStore} from "../../../api/api";
import StoreCornerListWhere from "../where/StoreCornerListWhere";

const StoreManage = (props) => {
    const {user} = useSelector((props) => props.account);
    const navigate = useNavigate();

    const [activeKey, setActiveKey] = useState(1)
    const [searchForm, setSearchForm] = useState({
        cmpCd: "",
        brandCd: "",
        storeCd: "",
        storeNm: "",
        manageDiv: "0"
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({visible: false, message: ""});
    const [rowData, setRowData] = useState([]);
    const [visible, setVisible] = useState(false);
    const [selectedStore, setSelectedStore] = useState({
        busiNo: "", taxidx: "", storeCd: null, storeNm: "", ownerNm: "", telNo: "", faxNo: "", rpresphno: "", addr1: "", addr2: "", email: "", openDate: "", useYn: 'Y',
        operateDiv: '1', authPassword:""
    });
    const [restStoreCd, setRestStoreCd] = useState("");

    const defaultColDef = {
        flex: 1,
        resizable: true,
        sortable: true,
        filter: false,
        autoHeaderHeight: true
    };

    const [columnDefs] = useState([
        {field: "storeCd", headerName: "매장코드", width: 100},
        {field: "storeNm", headerName: "매장명", width: 140},
        {field: "ownerNm", headerName: "대표자명", width: 90},
        {field: "useYn", headerName: "상태", width: 70}
    ]);

    const init = () => {
        setSelectedStore({
            busiNo: "", taxidx: "", storeCd: null, storeNm: "", ownerNm: "", telNo: "", faxNo: "", rpresphno: "", addr1: "", addr2: "", email: "", openDate: "", useYn: 'Y',
            operateDiv: '1', authPassword: ""
        });

        setRestStoreCd("");
    }

    const handlerStoreCd = (e) => {
        setRestStoreCd(e.target.value);
    }

    const requestStore = () => {
        const params = {
            taxNo: selectedStore.busiNo,
            taxidx: selectedStore.taxidx
        }
        setLoading(true);
        api.requestStore(params).then((result) => {
            const { responseBody, responseCode, responseMessage } = result.data;
            if (responseCode === "200") {
                if (responseBody != null) {
                    setSelectedStore(responseBody);
                }
                else {
                    alert("매장 정보가 존재하지 않습니다.");
                }
            }
        })
            .finally(() => {
                setLoading(false);
            })
    }

    const search = async () => {
        setError({visible: false, message: ""});
        const {cmpCd, brandCd, storeCd} = searchForm;
        if (cmpCd.length === 0) {
            setError({
                visible: true,
                message: "운영사 정보를 선택해주세요."
            });
            return;
        }

        const params = {
            cmpCd: cmpCd,
            brandCd: brandCd,
            userId: user.userId,
            storeCd: storeCd,
            manageDiv: searchForm.manageDiv
        };

        setLoading(true);
        try {
            const {data: result} = await api.getStoreWhere(params);
            const {responseBody, responseCode, responseMessage} = result;
            if (responseCode === "200") {
                // 성공
                setRowData(responseBody);
            } else {

            }
        } catch (e) {
            console.error(e.message);
        } finally {
            setLoading(false);
        }
    };

    const save = () => {
        setError({visible: false, message: ""});
        if (restStoreCd.length  === 0) {
            setError({
                visible: true, message: "매장 코드를 입력해주세요."
            })
            return;
        }

        if (confirm("저장하시겠습니까?")) {
            const store = {
                ...selectedStore,
                cmpCd: selectedStore.cmpCd === "" || selectedStore.cmpCd === null ? searchForm.cmpCd : selectedStore.cmpCd,
                brandCd: selectedStore.brandCd === "" || selectedStore.cmpCd === null ? searchForm.brandCd : selectedStore.brandCd,
                storeCd: restStoreCd,
                operateDiv: '1', useYn: 'Y', authPassword:selectedStore.authPassword,
                instUser: selectedStore.instUser ? selectedStore.instUser : user.userId,
                updUser: user.userId,
            }
            delete store.instTime;
            delete store.updTime;

            api.putStore(store).then((result) => {
                const {responseBody, responseCode, responseMessage} = result.data;
                if (responseCode === "200") {
                    // 성공
                    alert("정상적으로 처리되었습니다.");
                    search();
                } else {
                    setError({visible: true, message: responseMessage});
                }
            })
                .catch((error) => {
                    setError({visible: true, message:  error.message})
                })
        }
    }

    const containerStyle = useMemo(() => ({width: "100%", height: "100%"}), []);
    const gridStyle = useMemo(() => ({height: 450, width: "100%"}), []);

    const onRowSelected = useCallback((event) => {
        setRestStoreCd(event.node.data.storeCd);
        setSelectedStore(event.node.data);
        setVisible(true);
    }, []);

    const handleSelect = (code, value) => {
        if (value === "C") {
            setSearchForm((state) => ({
                ...state,
                cmpCd: code, brandCd: "", storeCd: "", cornerCd: ""
            }));
        } else if (value === "B") {
            setSearchForm((state) => ({
                ...state,
                cmpCd: state.cmpCd, brandCd: code, storeCd: "", cornerCd: ""
            }));
        } else if (value === "S") {
            setSearchForm((state) => ({
                ...state,
                cmpCd: state.cmpCd, brandCd: state.brandCd, storeCd: code, cornerCd: ""
            }));
        } else if (value === "O") {
            setSearchForm((state) => ({
                ...state,
                cmpCd: state.cmpCd, brandCd: state.brandCd, storeCd: state.storeCd, cornerCd: code
            }));
        }
    };

    return (
        <div style={containerStyle}>
            {loading ? <Loading/> : null}
            {error.visible ? <CAlert color="danger">{error.message}</CAlert> : null}
            <div className="d-grid gap-1 d-md-flex justify-content-between" style={{marginBottom: 10}}>
                <h5>매장정보관리</h5>
                <div>
                    <CButton size={"sm"} color="primary" onClick={search}>조회</CButton>
                </div>
            </div>
            <StoreCornerListWhere type={"S"} account={props.account} selected={searchForm}
                            onSelect={(c, v) => handleSelect(c, v)}/>
            <CForm className={"row row-cols-lg-auto g-1 align-items-center p-1"}>
                <CCol xs={12}>
                    <CInputGroup className={"mb-1"} size={"sm"}>
                        <CInputGroupText style={{width: 80}}>형태</CInputGroupText>
                        <CFormSelect id="manageDiv"
                                     value={searchForm.manageDiv}
                                     onChange={(e) => {
                                         setSearchForm((state) => ({
                                             ...state,
                                             manageDiv: e.target.value
                                         }));
                                     }}
                        >
                            <option value={"0"}>전체</option>
                            <option value={"1"}>직영</option>
                            <option value={"2"}>가맹</option>
                        </CFormSelect>
                    </CInputGroup>
                </CCol>
            </CForm>
            <div style={{height: 10}}/>
            <CRow>
                <CCol xs={5}>
                    <div className="ag-theme-alpine" style={gridStyle}>
                        {loading ? <Loading/> : null}
                        <AgGridReact
                            rowSelection={"single"}
                            onRowClicked={onRowSelected}
                            headerHeight={30}
                            rowHeight={30}
                            rowData={rowData}
                            animateRows={true}
                            defaultColDef={defaultColDef}
                            columnDefs={columnDefs}>
                        </AgGridReact>
                    </div>
                </CCol>
                <CCol>
                    <CNav variant="tabs" role="tablist">
                        <CNavItem>
                            <CNavLink
                                active={activeKey === 1}
                                onClick={() => setActiveKey(1)}>매장마스터</CNavLink>
                        </CNavItem>
                        <CNavItem>
                            <CNavLink
                                active={activeKey === 2}
                                onClick={() => setActiveKey(2)}>매장코너설정</CNavLink>
                        </CNavItem>
                    </CNav>
                    <CTabContent>
                        <CTabPane role="tabpanel" aria-labelledby="basic-tab" visible={activeKey === 1}>
                            <div style={{height: 10}}/>
                            <StoreDetail info={selectedStore}
                                         storeCd={restStoreCd}
                                         setStoreCd={handlerStoreCd}
                                         handler={setSelectedStore}
                                         init={init}
                                         search={requestStore}
                                         save={save}/>
                        </CTabPane>
                        <CTabPane role="tabpanel" aria-labelledby="basic-tab" visible={activeKey === 2}>
                            <div style={{height: 10}}/>
                            <StoreCorner info={selectedStore}/>
                        </CTabPane>
                    </CTabContent>
                </CCol>
            </CRow>
        </div>
    );
};

const mapStateToProps = (state) => {
    const {account, store, selected} = state;
    return {
        account, store, selected
    };
};

export default connect(mapStateToProps, null)(StoreManage);
